/* ==========================================================================
   MRPIECE — NIKE MIND LP  ·  mp-mind.js  ·  v1.0 (24 Aug 2026)
   One controller for the whole page. No libraries, no rAF loops.
   Namespace: window.__mpMindLP  (mp-offer-progress owns window.__mpCartCta)
   ========================================================================== */
(function () {
  'use strict';
  if (window.__mpMindLP) return;
  window.__mpMindLP = true;

  var root = document.documentElement;
  var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- config ------------------------------------------------------ */
  var cfg = { motion: 'medium', qualifyingTypes: ['slides', 'slippers', 'sandals'], tier2: 15, tier3: 20, fallback: 10, moneyFormat: 'LE {{amount_no_decimals}}' };
  try {
    var el = document.querySelector('[data-mind-config]');
    if (el) cfg = Object.assign(cfg, JSON.parse(el.textContent));
  } catch (e) {}

  root.classList.add('mind-js', 'mind-lp');
  root.setAttribute('data-mind-motion', REDUCED ? 'off' : cfg.motion || 'medium');
  var MOTION = root.getAttribute('data-mind-motion') !== 'off';

  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };

  /* ---------- 1 · reveal -------------------------------------------------- */
  var revealIO = null;
  function reveal() {
    var nodes = $$('[data-mind-reveal]:not(.is-in)');
    if (!nodes.length) return;
    if (!MOTION || !('IntersectionObserver' in window)) {
      nodes.forEach(function (n) { n.classList.add('is-in'); });
      return;
    }
    if (!revealIO) {
      revealIO = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (!en.isIntersecting) return;
          en.target.classList.add('is-in');
          revealIO.unobserve(en.target);
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });
    }
    nodes.forEach(function (n) { revealIO.observe(n); });
  }

  /* stagger children of any [data-mind-stagger] container */
  function applyStagger() {
    $$('[data-mind-stagger]').forEach(function (box) {
      var step = parseInt(box.getAttribute('data-mind-stagger'), 10) || 60;
      $$('[data-mind-reveal]', box).forEach(function (kid, i) {
        if (!kid.style.getPropertyValue('--mind-d')) kid.style.setProperty('--mind-d', i * step + 'ms');
      });
    });
  }

  /* ---------- 2 · hero entrance ------------------------------------------ */
  function heroSequence() {
    var hero = $('[data-mind-hero]');
    if (!hero) return;
    $$('.mind-line > span', hero).forEach(function (s, i) {
      if (!s.style.getPropertyValue('--mind-d')) s.style.setProperty('--mind-d', 140 + i * 90 + 'ms');
    });
    requestAnimationFrame(function () {
      requestAnimationFrame(function () { hero.classList.add('is-ready'); });
    });
  }

  /* ---------- 3 · colour tint + filter ----------------------------------- */
  var colorMap = {};
  function loadColorMap() {
    var s = $('[data-mind-colormap]');
    if (!s) return;
    try { colorMap = JSON.parse(s.textContent) || {}; } catch (e) { colorMap = {}; }
  }

  function handleOf(card) {
    var a = card.querySelector('a.product-card__title[href], a[href*="/products/"]');
    if (!a) return null;
    var m = a.getAttribute('href').match(/\/products\/([^?#/]+)/);
    if (!m) return null;
    try { return decodeURIComponent(m[1]); } catch (e) { return m[1]; }
  }

  function decorateCards() {
    $$('.product-card').forEach(function (card) {
      if (card.dataset.mindDone) return;
      var h = handleOf(card);
      var cols = (h && colorMap[h]) || [];
      card.dataset.mindDone = '1';
      card.dataset.mindColors = cols.join(' ');
      if (cols.length) card.dataset.mindTint = cols[0];
    });
  }

  var activeColor = '';
  function applyFilter(color) {
    activeColor = color || '';
    var shown = 0;
    $$('.product-card').forEach(function (card) {
      var cols = (card.dataset.mindColors || '').split(' ').filter(Boolean);
      var ok = !activeColor || cols.indexOf(activeColor) > -1;
      card.classList.toggle('mind-hidden', !ok);
      if (ok) shown++;
    });
    $$('[data-mind-chip]').forEach(function (b) {
      b.setAttribute('aria-pressed', String(b.getAttribute('data-mind-chip') === activeColor));
    });
    var live = $('[data-mind-filter-status]');
    if (live) {
      var noun = shown === 1 ? ' product' : ' products';
      live.textContent = activeColor ? shown + noun + ' in ' + activeColor : shown + noun;
    }
    var empty = $('[data-mind-filter-empty]');
    if (empty) empty.hidden = shown !== 0;
    var count = document.getElementById('ProductCount');
    if (count && activeColor) count.setAttribute('data-mind-overridden', '1');
  }

  function bindChips() {
    $$('[data-mind-chip]').forEach(function (btn) {
      if (btn.dataset.mindBound) return;
      btn.dataset.mindBound = '1';
      btn.addEventListener('click', function () {
        var v = btn.getAttribute('data-mind-chip');
        applyFilter(v === activeColor ? '' : v);
        var grid = $('#ProductGridContainer');
        if (grid && v !== activeColor) grid.scrollIntoView({ behavior: REDUCED ? 'auto' : 'smooth', block: 'start' });
      });
    });
  }

  /* ---------- 4 · money -------------------------------------------------- */
  function money(cents) {
    var f = cfg.moneyFormat || 'LE {{amount_no_decimals}}';
    var v = (cents || 0) / 100;
    function group(n, dec) {
      var parts = n.toFixed(dec).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      return parts.join('.');
    }
    return f
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, group(v, 0))
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, group(v, 2))
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, group(v, 0))
      .replace(/\{\{\s*amount\s*\}\}/g, group(v, 2));
  }

  /* ---------- 5 · offer state ------------------------------------------- */
  var lastTier = null;

  function tierFrom(cart) {
    var q = 0;
    (cart.items || []).forEach(function (it) {
      var t = String(it.product_type || '').toLowerCase();
      if (cfg.qualifyingTypes.indexOf(t) > -1) q += it.quantity;
    });
    var total = cart.item_count || 0;
    if (q >= 3) return { tier: 3, q: q, total: total, pct: cfg.tier3, p: 1, title: cfg.tier3 + '% off unlocked', sub: 'Best price on the drop' };
    if (q === 2) return { tier: 2, q: q, total: total, pct: cfg.tier2, p: 0.66, title: cfg.tier2 + '% off unlocked', sub: 'Add 1 more pair for ' + cfg.tier3 + '% off' };
    if (q === 1) return { tier: 1, q: q, total: total, pct: 0, p: 0.33, title: 'One more pair to go', sub: 'Add a second pair — ' + cfg.tier2 + '% off both' };
    if (total >= 2) return { tier: 0.5, q: q, total: total, pct: cfg.fallback, p: 0.5, title: cfg.fallback + '% off unlocked', sub: 'Add 2 pairs from this drop for ' + cfg.tier2 + '%' };
    return { tier: 0, q: q, total: total, pct: 0, p: 0, title: 'Pick 2 pairs — save ' + cfg.tier2 + '%', sub: '3 pairs save ' + cfg.tier3 + '%' };
  }

  function paint(cart) {
    var s = tierFrom(cart);

    /* offer section progress */
    var prog = $('[data-mind-prog]');
    if (prog) {
      prog.style.setProperty('--mind-p', s.p);
      var lab = $('[data-mind-prog-label]', prog);
      if (lab) lab.textContent = s.title;
      $$('[data-mind-prog-dots] i', prog).forEach(function (d, i) { d.classList.toggle('on', i < Math.min(s.q, 3)); });
    }

    /* sticky mobile bar */
    var st = $('[data-mind-sticky]');
    if (st) {
      st.style.setProperty('--mind-p', s.p);
      var t = $('[data-mind-sticky-title]', st);
      var sub = $('[data-mind-sticky-sub]', st);
      var cta = $('[data-mind-sticky-cta]', st);
      if (t) t.textContent = s.title;
      if (sub) sub.textContent = s.total ? s.total + (s.total === 1 ? ' item' : ' items') + ' · ' + money(cart.total_price) : s.sub;
      if (cta) {
        var label = $('[data-mind-sticky-cta-label]', cta) || cta;
        label.textContent = s.total ? 'View cart' : 'Shop the drop';
        cta.setAttribute('data-mode', s.total ? 'cart' : 'shop');
      }
    }

    /* one-shot celebration when a tier is newly unlocked */
    if (lastTier !== null && s.tier > lastTier && (s.tier === 2 || s.tier === 3)) celebrate();
    lastTier = s.tier;
  }

  function fetchCart() {
    var url = (window.theme && window.theme.routes && window.theme.routes.cart_url) || '/cart';
    return fetch(url + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (c) { if (c) paint(c); })
      .catch(function () {});
  }

  /* ---------- 6 · celebration (one shot, self-removing) ------------------ */
  function celebrate() {
    if (!MOTION || REDUCED) return;
    var wrap = document.createElement('div');
    wrap.className = 'mind-pop';
    var colors = ['#ff4d0a', '#0e5fd9', '#c8ff00', '#ff5fa2', '#ffffff'];
    for (var i = 0; i < 26; i++) {
      var p = document.createElement('i');
      var a = Math.random() * Math.PI * 2;
      var d = 90 + Math.random() * 190;
      p.style.background = colors[i % colors.length];
      p.style.setProperty('--dx', Math.cos(a) * d + 'px');
      p.style.setProperty('--dy', Math.sin(a) * d - 60 + 'px');
      p.style.setProperty('--dr', Math.random() * 720 - 360 + 'deg');
      p.style.animationDelay = Math.random() * 90 + 'ms';
      wrap.appendChild(p);
    }
    document.body.appendChild(wrap);
    setTimeout(function () { wrap.remove(); }, 1200);
  }

  /* ---------- 7 · quick-add feedback ------------------------------------ */
  var pendingBtn = null;
  document.addEventListener(
    'click',
    function (e) {
      var b = e.target.closest && e.target.closest('.mind-lp .quick-add button, .mind-lp form[action*="/cart/add"] button[type="submit"]');
      if (b) pendingBtn = b;
    },
    true
  );

  function flashAdded() {
    if (!pendingBtn) return;
    var b = pendingBtn;
    pendingBtn = null;
    b.classList.add('mind-added');
    setTimeout(function () { b.classList.remove('mind-added'); }, 1600);
  }

  /* cart icon nudge */
  function bumpCartIcon() {
    if (!MOTION) return;
    var icon = $('[aria-controls="CartDrawer"]') || $('.header__icon--cart') || $('cart-count');
    if (!icon) return;
    icon.animate(
      [{ transform: 'scale(1)' }, { transform: 'scale(1.18)' }, { transform: 'scale(1)' }],
      { duration: 340, easing: 'cubic-bezier(.16,1,.3,1)' }
    );
  }

  /* ---------- 8 · magnetic CTA (desktop, pointer only) ------------------ */
  function magnets() {
    if (!MOTION || !window.matchMedia('(hover:hover) and (pointer:fine)').matches) return;
    $$('[data-mind-magnet]').forEach(function (b) {
      if (b.dataset.mindMagnetBound) return;
      b.dataset.mindMagnetBound = '1';
      var raf = 0;
      b.addEventListener('pointermove', function (e) {
        if (raf) return;
        raf = requestAnimationFrame(function () {
          raf = 0;
          var r = b.getBoundingClientRect();
          var dx = (e.clientX - (r.left + r.width / 2)) / r.width;
          var dy = (e.clientY - (r.top + r.height / 2)) / r.height;
          b.style.transform = 'translate3d(' + (dx * 5).toFixed(2) + 'px,' + (dy * 4).toFixed(2) + 'px,0)';
        });
      });
      b.addEventListener('pointerleave', function () { b.style.transform = ''; });
    });
  }

  /* ---------- 9 · final CTA floats (pointer parallax, visibility-gated) -- */
  function floats() {
    var box = $('[data-mind-floats]');
    if (!box || !MOTION || !window.matchMedia('(hover:hover) and (pointer:fine)').matches) return;
    var imgs = $$('img', box);
    if (!imgs.length) return;
    var live = false, raf = 0;

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (en) { live = en[0].isIntersecting; }, { threshold: 0.05 }).observe(box);
    } else live = true;

    window.addEventListener(
      'pointermove',
      function (e) {
        if (!live || raf) return;
        raf = requestAnimationFrame(function () {
          raf = 0;
          var cx = e.clientX / window.innerWidth - 0.5;
          var cy = e.clientY / window.innerHeight - 0.5;
          imgs.forEach(function (im, i) {
            var k = (i % 2 ? -1 : 1) * (10 + i * 3);
            im.style.setProperty('--mx', (cx * k).toFixed(1) + 'px');
            im.style.setProperty('--my', (cy * k).toFixed(1) + 'px');
          });
        });
      },
      { passive: true }
    );
  }

  /* ---------- 10 · sticky bar visibility -------------------------------- */
  function stickyBar() {
    var st = $('[data-mind-sticky]');
    if (!st) return;
    root.classList.add('mind-sticky-on');
    var anchor = $('[data-mind-hero]') || $('.mind-hero');
    if (!anchor || !('IntersectionObserver' in window)) { st.classList.add('is-on'); return; }
    new IntersectionObserver(
      function (en) { st.classList.toggle('is-on', !en[0].isIntersecting); },
      { threshold: 0 }
    ).observe(anchor);

    var cta = $('[data-mind-sticky-cta]', st);
    if (cta) {
      cta.addEventListener('click', function (e) {
        if (cta.getAttribute('data-mode') !== 'cart') return;
        e.preventDefault();
        document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { open: true } }));
      });
    }
  }

  /* ---------- boot ------------------------------------------------------- */
  function decorate() {
    applyStagger();
    reveal();
    loadColorMap();
    decorateCards();
    bindChips();
    magnets();
    if (activeColor) applyFilter(activeColor);
  }

  function init() {
    decorate();
    heroSequence();
    stickyBar();
    floats();
    fetchCart();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  /* re-decorate after the theme re-renders the grid (facets / infinite scroll) */
  document.addEventListener('collection:reloaded', decorate);

  /* cart hooks — cart:updated is the confirmed post-swap event in this theme */
  document.addEventListener('cart:updated', function () { flashAdded(); bumpCartIcon(); fetchCart(); });
  document.addEventListener('ajaxProduct:added', function () { flashAdded(); bumpCartIcon(); fetchCart(); });
  window.addEventListener('pageshow', function (e) { if (e.persisted) fetchCart(); });
})();
